import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { AUTH_URL } from "../../../utils/constants";

const OtpVerification = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");

  const handleVerify = async () => {
    if (!otp.trim()) {
      setError("OTP is required.");
      return;
    }
    try {
      let response = await axios.post(
        `${AUTH_URL}userregisterotp`,
        { email: sessionStorage.getItem("email"), otp: otp },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response?.data?.status) {
        console.log(response.data, "line26");
        navigate("/botDesk");
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `${response?.data?.message}`,
        });
      }
    } catch (error) {
      console.log("Error in otp verification api", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${error.response?.data?.message}`,
      });
    }
    // navigate("/Desk");
    setError("");
  };

  return (
    <div className="mt-9 flex flex-col items-center justify-center py-[30px]">
      <div className="w-1/3 border shadow-lg rounded-sm bg-white p-4">
        <h1 className="mb-4 text-lg text-center font-bold text-black">
          OTP Verification
        </h1>
        <p className="mt-2 text-center text-gray-700">
          Please enter the otp sent to your email.
        </p>

        <div className="my-6">
          <label
            htmlFor="otp"
            className="block text-sm font-medium text-center text-gray-700"
          >
            OTP <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            id="otp"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className={`block w-full mt-2 p-2 bg-gray-200 border rounded-md shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 ${
              error ? "border-red-500" : "border-gray-300"
            }`}
            placeholder="Enter OTP"
          />
          {error && (
            <p className="mt-2 text-sm text-red-500 text-center">{error}</p>
          )}
        </div>

        <div className="flex justify-center mt-6">
          <button
            className="w-1/2 bg-[#251e8a] text-white py-1.5 rounded-md shadow-md transition duration-300"
            onClick={handleVerify}
          >
            Verify
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtpVerification;
